import { staticText } from '../../../utils/translations/staticText';

const baseTranslations = {
  giftsAvailable: {
    _: "Don't miss out on exclusive rewards...",
    zh: '不要錯過獨家獎勵...',
  },
  giftsNotAvailable: {
    _: "You're almost done!",
    zh: '您快完成了！',
  },
  back: {
    _: 'Back',
    zh: '返回',
  },
  noRewards: {
    _: 'No rewards available for this product',
    zh: '此產品沒有可用的獎勳',
  },
  multipleRewards: {
    _: "You'll get to choose one of these rewards:",
    zh: '您可以選擇以下其中一項獎勵:',
  },
  multipleGiftsAvailable: {
    _: "Plus, you'll get:",
    zh: '此外，您還將獲得:',
  },
  multipleGiftsNotAvailable: {
    _: 'You will get this reward:',
    zh: '您將獲得以下獎勵:',
  },
  termsCampaign: {
    _: '*Campaign',
    zh: '公司的',
  },
  termsApply: {
    _: '*T&Cs apply',
    zh: 'T&Cs 已到位',
  },
  // BrandUserInfo translations
  originalPrice: {
    _: 'Original premium',
    zh: '原始保費',
  },
  discountPrice: {
    _: "You'll pay only",
    zh: '您只需支付',
  },
  vehicleMake: {
    _: 'Vehicle make',
    zh: '汽車品牌',
  },
  vehicleModel: {
    _: 'Vehicle model',
    zh: '車型',
  },
  variant: {
    _: 'Variant',
    zh: '車款',
  },
  manufactureYear: {
    _: 'Manufacture year',
    zh: '製造年份',
  },
  gender: {
    _: 'Gender',
    zh: '性別',
  },
  genderMale: {
    _: 'Male',
    zh: '男',
  },
  genderFemale: {
    _: 'Female',
    zh: '女',
  },
  maritalStatus: {
    _: 'Marital status',
    zh: '婚姻狀況',
  },
  maritalStatusSingle: {
    _: 'Single',
    zh: '單身',
  },
  maritalStatusMarried: {
    _: 'Married',
    zh: '已婚',
  },
  age: {
    _: 'Age',
    zh: '年齡',
  },
  ageYears: {
    _: 'y.o.',
    zh: '歲',
  },
  drivingExperience: {
    _: 'Driving experience',
    zh: '駕駛經驗',
  },
  drivingExperience0Years: {
    _: '0 years',
    zh: '0 年',
  },
  drivingExperience1Year: {
    _: '1 year',
    zh: '1 年',
  },
  drivingExperience2Years: {
    _: '2 years',
    zh: '2 年',
  },
  drivingExperience3PlusYears: {
    _: '3 years and above',
    zh: '3 年及以上',
  },
  ncd: {
    _: 'NCD',
    zh: '無索償折扣',
  },
  numberOfClaims: {
    _: 'Number of claims in last 3 years',
    zh: '過去3年內的理賠次數',
  },
  priceSymbol: {
    _: '$',
    zh: '$',
  },
  startingAt: {
    _: 'Starting at',
    zh: '起價為',
  },
  shareEmail: {
    _: 'Share your email address to receive the rewards claim form.',
    zh: '提供您的電子郵件地址，以接收報獎表格。',
  },
  emailError: {
    _: 'Please enter a valid email address',
    zh: '請輸入有效的電子郵件地址',
  },
  redirect: {
    _: "You'll be redirected to",
    zh: '您將被重定向到',
  },
  buy: {
    _: 'Continue',
    zh: '繼續購買',
  },
  subscribe: {
    _: 'I consent to receiving marketing materials from SingSaver Pte Ltd / SingSaver Insurance Brokers Pte Ltd about their products, services, offers & events by email, phone call, IM or text as per their',
    zh: ' 我同意通過電子郵件、電話、即時消息或短信接收有關 MoneyHero Global Limited / MoneyHero Insurance Brokers Limited 的產品、服務、優惠和活動的營銷材料，並且同意其',
  },
  privacyPolicy: {
    _: 'Privacy Policy.',
    zh: '隱私政策。',
  },
  termsBy: {
    _: "By entering your email address, you agree to SingSaver's",
    zh: '輸入您的電子郵件地址，即表示您同意 MoneyHero 的',
  },
  termsAndConditions: {
    _: 'T&Cs',
    zh: '使用條款',
  },
  and: {
    _: 'and',
    zh: '和',
  },
  privacyPolicyFooter: {
    _: 'Privacy Policy.',
    zh: '隱私權政策。',
  },
};

export const EXCLUSIVE_REWARDS_TRANSLATIONS = staticText(baseTranslations);

export type ExclusiveRewardsStaticText = typeof baseTranslations;
